import { useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';
import { useAuth } from '@/hooks/useAuth';

export function useAtualizarUltimoAcesso() {
  const { user } = useAuth();

  useEffect(() => {
    if (!user) return;

    const atualizarAcesso = async () => {
      try {
        await supabase
          .from('usuarios')
          .update({ ultimo_acesso: new Date().toISOString() })
          .eq('id', user.id);
      } catch (error) {
        console.error('Erro ao atualizar último acesso:', error);
      }
    };

    // Atualizar imediatamente ao montar
    atualizarAcesso();

    // Atualizar a cada 5 minutos
    const interval = setInterval(atualizarAcesso, 5 * 60 * 1000);

    return () => clearInterval(interval);
  }, [user]);
}
